module.exports = __webpack_public_path__ + "8242a261bdea4e21ca9b885f76df6a78.jpg";